import makeCrud from '@/store/site/localization/crud'

// Satın almalar (PO) — CRUD; receive/transition aksiyonları sayfa içinde axios ile.
export default makeCrud('ecommerce_stock_purchase')
